module.exports = __webpack_public_path__ + "img/IMG_3888.c2dfc9ea.jpg";